import { Select, ISelect } from "./";
import { getSectors } from "../../../apis/public.api";
import { useEffect, useState } from "react";
import { textChooser } from "../../../util/textChooser";
import { formatValuesForSelect } from "../../../helpers/utilities";

interface SectorProps extends ISelect {}

export const Sector = (props: SectorProps) => {

    const [sector, setSector] = useState([]);

    useEffect(() => {
        getSectors().then((sectorsData) => {
            formatValuesForSelect(setSector, sectorsData)
        })
    },[])

    return(
        <Select 
            {...props} 
            label={props?.label ?? textChooser("txt104")}
            values={sector} 
            currentValue={props.currentValue} 
        />
    )
}